var _path, _path2, _path3, _circle, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFp11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15,3.17c-6.52,0-11.83,5.31-11.83,11.83s5.31,11.83,11.83,11.83,11.83-5.31,11.83-11.83S21.52,3.17,15,3.17Zm0,22.08c-5.65,0-10.25-4.6-10.25-10.25S9.35,4.75,15,4.75s10.25,4.6,10.25,10.25-4.6,10.25-10.25,10.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.58,15c0-4.15,1.64-8.06,4.4-10.44.33-.29.37-.79.08-1.12-.29-.33-.79-.37-1.12-.08C1.85,6.04,0,10.39,0,15s1.85,8.96,4.95,11.64c.15.13.33.19.52.19.22,0,.44-.09.6-.27.29-.33.25-.83-.08-1.12-2.75-2.38-4.4-6.29-4.4-10.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.85,3.26c-.34-.28-.84-.23-1.12.11-.28.34-.23.84.11,1.12,2.87,2.37,4.58,6.33,4.58,10.59s-1.65,8.08-4.42,10.46c-.33.29-.37.79-.08,1.12.16.18.38.28.6.28.18,0,.37-.06.52-.19,3.11-2.68,4.97-7.04,4.97-11.66s-1.93-9.15-5.15-11.81Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1.82
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.04 13.51 6.76 13.51 6.76 16.49 9.04 16.49 9.04 17.6 11.95 15 9.04 12.4 9.04 13.51"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.96 13.51 20.96 12.4 18.05 15 20.96 17.6 20.96 16.49 23.24 16.49 23.24 13.51 20.96 13.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFp11);
export default __webpack_public_path__ + "static/media/FP11.e2f08082cb1f13fe8ce8c95a2f028aa4.svg";
export { ForwardRef as ReactComponent };